module.exports = __webpack_public_path__ + "img/candela-client-integration-dark-01.6b9faa92.png";